import CardModal from '../CardModal';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import SVGArrow from '@/components/UI/svg/corporatesocialresponsibility/SVGArrow';

export default function D() {
    const { useEffect, useState, useLang, useRouter } = useGlobal();
    const { t } = useLang('corporatesocialresponsibility');
    const { locale } = useRouter();
    const [visible, setVisible] = useState(false);
    const [modalInfo, setModalInfo] = useState({});
    const [active, setActive] = useState(0);

    const cards: any = [
        {
            title: t('secD_card6_text'),
            desc: t('secD_card6_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/common/C1.jpg'),
            img: require('@publicLocal/corporate-social-responsibility/common/C1.jpg'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/common/C1.jpg'), require('@publicLocal/corporate-social-responsibility/common/C1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/C2.jpg'), require('@publicLocal/corporate-social-responsibility/common/C2.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/C3.jpg'), require('@publicLocal/corporate-social-responsibility/common/C3.jpg')],
            ],
        },
        {
            title: t('secD_card1_text'),
            desc: t('secD_card1_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/4_1_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/h5/4_1_1.png'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/4_1_1.webp'), require('@publicLocal/corporate-social-responsibility/h5/4_1_1.png')],
                [require('@publicLocal/corporate-social-responsibility/h5/4_1_2.webp'), require('@publicLocal/corporate-social-responsibility/h5/4_1_2.png')],
            ],
        },
        {
            title: t('secD_card2_text'),
            desc: t('secD_card2_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/4_2_1.jpg'),
            img: require('@publicLocal/corporate-social-responsibility/h5/4_2_1.jpg'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/4_2_1.jpg'), require('@publicLocal/corporate-social-responsibility/h5/4_2_1.jpg')],
            ],
        },
        {
            title: t('secD_card3_text'),
            desc: t('secD_card3_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/4_3_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/h5/4_3_1.png'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/4_3_1.webp'), require('@publicLocal/corporate-social-responsibility/h5/4_3_1.png')],
                [require('@publicLocal/corporate-social-responsibility/h5/4_3_2.webp'), require('@publicLocal/corporate-social-responsibility/h5/4_3_2.png')],
                [require('@publicLocal/corporate-social-responsibility/h5/4_3_3.webp'), require('@publicLocal/corporate-social-responsibility/h5/4_3_3.png')],
            ],
        },
        {
            title: t('secD_card4_text'),
            desc: t('secD_card4_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/4_4_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/h5/4_4_1.png'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/4_4_1.webp'), require('@publicLocal/corporate-social-responsibility/h5/4_4_1.png')],
                [require('@publicLocal/corporate-social-responsibility/h5/4_4_2.webp'), require('@publicLocal/corporate-social-responsibility/h5/4_4_2.png')],
            ],
        },
        {
            title: t('secD_card5_text'),
            desc: t('secD_card5_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/4_5_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/h5/4_5_1.png'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/4_5_1.webp'), require('@publicLocal/corporate-social-responsibility/h5/4_5_1.png')],
                [require('@publicLocal/corporate-social-responsibility/h5/4_5_2.webp'), require('@publicLocal/corporate-social-responsibility/h5/4_5_2.png')],
            ],
        },
    ];

    const clickCard = (card: any) => {
        setVisible(true);
        setModalInfo({
            title: card?.title,
            desc: card?.desc,
            imgs: card?.imgArr,
        });
    };

    let originX = 0,
        startX = 0,
        endsX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        endsX = endX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    const onTouchEnd = (e: any) => {
        const target = document.querySelector('.csr-D .card-lists') as HTMLDivElement;
        // if (endsX <= 0 && endsX >= window.innerWidth - target?.offsetWidth) {
        const cardW = (window.innerWidth / 375) * 320;
        const gapW = (window.innerWidth / 375) * 10;
        const paddingW = (window.innerWidth / 375) * 25;
        const n = Math.floor(Math.abs(endsX - paddingW) / (cardW + gapW));
        const r = (Math.abs(endsX - paddingW) % (cardW + gapW)) / (cardW + gapW);
        setActive(r >= 0.5 ? n + 1 : n);
        // }
    };
    return (
        <div className={`csr-D ${css['csr-D']}`}>
            <div className="secD">
                <div className="content-box">
                    <div className="text-box">
                        <p className="title">{t('secD_title')}</p>
                        <p className="desc">{t('secD_desc')}</p>
                    </div>
                    <div className="card-box">
                        <div className="card-lists" onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>
                            {cards?.map((card: any, k: number) => (
                                <div className={`card card${k + 1}`} onClick={() => clickCard(card)} key={k}>
                                    <div className="img">
                                        <NextImage webpSrc={card?.webpImg || card.img} src={card.img} alt={card?.title} aria-label={card?.title} />
                                    </div>
                                    <div className="text-bar">
                                        <p className="text">{card?.title}</p>
                                        <SVGArrow />
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="paginations">
                            {cards?.map((_: any, k: number) => (
                                <span className={`dot ${active === k ? 'active' : ''}`} key={k}></span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {visible && <CardModal title={modalInfo?.title} desc={modalInfo?.desc} imgs={modalInfo?.imgs} onClose={() => setVisible(false)} />}
        </div>
    );
}
